enum ClaimCommentType {
  undefined = 'Undefined',
  internal = 'Internal',
  external = 'External',
}
export default ClaimCommentType;
export type VerifyClaimCommentType = Utils.VerifyExtends<Model.Enum.ClaimCommentType, Utils.ValueOf<typeof ClaimCommentType>>;
